/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { TitleWithLink } from "@farmlands/ui-library";
import _ from "lodash";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
  AgreementList,
  DEFAULT_EMPTY_AGREEMENTS_LIST_MESSAGE,
} from "@/features/sales-agreements/components/AgreementList";
import { AgreementListItem } from "@/features/sales-agreements/components/AgreementListItem";
import { TestIds } from "@/testIds";

import {
  selectActiveSalesAgreements,
  selectAllSalesAgreements,
} from "../../sales-agreements/storage";

export const ActiveSalesAgreementsSection = () => {
  const navigate = useNavigate();
  const salesAgreements = useSelector(selectAllSalesAgreements);
  const activeAgreements = useSelector(selectActiveSalesAgreements);

  const list = useMemo(() => activeAgreements.slice(0, 2), [activeAgreements]);

  if (_.isEmpty(salesAgreements)) {
    return null;
  }

  return (
    <div className="flex flex-col gap-2" data-testid={TestIds.feat.home.agreementsSection}>
      <TitleWithLink
        title="Agreements"
        linkTitle="All agreements"
        linkTo={() => navigate("/agreements")}
        testId={TestIds.feat.dashboard.list.viewAllAgreements}
      />
      <AgreementList emptyListMessage={DEFAULT_EMPTY_AGREEMENTS_LIST_MESSAGE}>
        {list.map((agreement) => (
          <AgreementListItem
            key={agreement.id}
            {...agreement}
            products={agreement.lines.map((line) => line.productDescription)}
            percentageFulfilled={agreement.percentageFulfilled}
          />
        ))}
      </AgreementList>
    </div>
  );
};
